import { AddChildButton, EditNode, EditNodeToolbar } from "@react-admin/ra-tree";
import { SimpleForm, TopToolbar } from "react-admin";
import TreeNodeForm from "./TreeNodeForm";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";

const TreeNodeEdit = () => {
  return (
    <EditNode
      mutationMode="pessimistic"
      title="Меню елемент"
      mutationOptions={{ meta: { useFormData: false } }}
      actions={
        <TopToolbar>
          <SecuredComponent permission={permissions.canChangeTreeStructure}>
            <AddChildButton />
          </SecuredComponent>
        </TopToolbar>
      }
    >
      <SimpleForm
        toolbar={
          <SecuredComponent permission={permissions.canChangeTreeStructure}>
            <EditNodeToolbar />
          </SecuredComponent>
        }
      >
        <TreeNodeForm />
      </SimpleForm>
    </EditNode>
  );
};

export default TreeNodeEdit;
